import { tokens } from "../theme"

export const mockDataTeam=[
    {
        id:1,
        name:"John Snow",
        email:"johnsnow@gmail.com",
        age:35,
        phone:"0798556709",
        access:"admin"
    },
    {
        id:2,
        name:"John Snow",
        email:"johnsnow@gmail.com",
        age:35,
        phone:"0798556709",
        access:"admin"
    },
    {
        id:3,
        name:"John Snow",
        email:"johnsnow@gmail.com",
        age:35,
        phone:"0798556709",
        access:"manager"
    },
    {
        id:4,
        name:"John Snow",
        email:"johnsnow@gmail.com",
        age:35,
        phone:"0798556709",
        access:"user"
    },
    {
        id:5,
        name:"John Snow",
        email:"johnsnow@gmail.com",
        age:35,
        phone:"0798556709",
        access:"admin"
    },
    {
        id:6,
        name:"John Snow",
        email:"johnsnow@gmail.com",
        age:35,
        phone:"0798556709",
        access:"user"
    },
]


export const mockDataContacts=[
    {
        id:1,
        name:"John Snow",
        email:"johnsnow@gmail.com",
        age:35,
        phone:"0798556709",
        address:"127m, off main Road Sagana",
        city:"Sagana",
        zipCode:"10001",
        registrarId:12543,
    },
    {
        id:2,
        name:"John Snow",
        email:"johnsnow@gmail.com",
        age:35,
        phone:"0798556709",
        address:"127m, off main Road Sagana",
        city:"Sagana",
        zipCode:"10001",
        registrarId:12543,
    },
    {
        id:3,
        name:"John Snow",
        email:"johnsnow@gmail.com",
        age:35,
        phone:"0798556709",
        address:"127m, off main Road Sagana",
        city:"Sagana",
        zipCode:"10001",
        registrarId:12543,
    },
    {
        id:4,
        name:"John Snow",
        email:"johnsnow@gmail.com",
        age:35,
        phone:"0798556709",
        address:"127m, off main Road Sagana",
        city:"Sagana",
        zipCode:"10001",
        registrarId:12543,
    },
    {
        id:5,
        name:"John Snow",
        email:"johnsnow@gmail.com",
        age:35,
        phone:"0798556709",
        address:"127m, off main Road Sagana",
        city:"Sagana",
        zipCode:"10001",
        registrarId:12543,
    },
    {
        id:6,
        name:"John Snow",
        email:"johnsnow@gmail.com",
        age:35,
        phone:"0798556709",
        address:"127m, off main Road Sagana",
        city:"Sagana",
        zipCode:"10001",
        registrarId:12543,
    }
]

export const mockDataInvoices=[
    {
        id:1,
        name:"Jon Snow",
        email:"johnsnow@gmail.com",
        cost:"21.24",
        phone:"0798556709",
        date:"03/12/2022"
    },
    {
        id:2,
        name:"Jon Snow",
        email:"johnsnow@gmail.com",
        cost:"21.24",
        phone:"0798556709",
        date:"03/12/2022"
    },
    {
        id:3,
        name:"Jon Snow",
        email:"johnsnow@gmail.com",
        cost:"21.24",
        phone:"0798556709",
        date:"03/12/2022"
    },
    {
        id:4,
        name:"Jon Snow",
        email:"johnsnow@gmail.com",
        cost:"21.24",
        phone:"0798556709",
        date:"03/12/2022"
    },
    {
        id:5,
        name:"Jon Snow",
        email:"johnsnow@gmail.com",
        cost:"21.24",
        phone:"0798556709",
        date:"03/12/2022"
    },
    {
        id:6,
        name:"Jon Snow",
        email:"johnsnow@gmail.com",
        cost:"21.24",
        phone:"0798556709",
        date:"03/12/2022"
    },
]

export const mockDataBarChart=[
  {
    "country": "AD",
    "hot dog": 30,
    "hot dogColor": "hsl(127, 70%, 50%)",
    "burger": 19,
    "burgerColor": "hsl(210, 70%, 50%)",
    "sandwich": 80,
    "sandwichColor": "hsl(288, 70%, 50%)",
    "kebab": 183,
    "kebabColor": "hsl(121, 70%, 50%)",
    "fries": 14,
    "friesColor": "hsl(38, 70%, 50%)",
    "donut": 119,
    "donutColor": "hsl(236, 70%, 50%)"
  },
  {
    "country": "AE",
    "hot dog": 156,
    "hot dogColor": "hsl(264, 70%, 50%)",
    "burger": 192,
    "burgerColor": "hsl(57, 70%, 50%)",
    "sandwich": 40,
    "sandwichColor": "hsl(233, 70%, 50%)",
    "kebab": 18,
    "kebabColor": "hsl(337, 70%, 50%)",
    "fries": 57,
    "friesColor": "hsl(56, 70%, 50%)",
    "donut": 165,
    "donutColor": "hsl(303, 70%, 50%)"
  },
  {
    "country": "AF",
    "hot dog": 146,
    "hot dogColor": "hsl(205, 70%, 50%)",
    "burger": 135,
    "burgerColor": "hsl(27, 70%, 50%)",
    "sandwich": 198,
    "sandwichColor": "hsl(160, 70%, 50%)",
    "kebab": 25,
    "kebabColor": "hsl(233, 70%, 50%)",
    "fries": 43,
    "friesColor": "hsl(318, 70%, 50%)",
    "donut": 156,
    "donutColor": "hsl(334, 70%, 50%)"
  },
  {
    "country": "AG",
    "hot dog": 34,
    "hot dogColor": "hsl(35, 70%, 50%)",
    "burger": 29,
    "burgerColor": "hsl(344, 70%, 50%)",
    "sandwich": 39,
    "sandwichColor": "hsl(356, 70%, 50%)",
    "kebab": 55,
    "kebabColor": "hsl(211, 70%, 50%)",
    "fries": 133,
    "friesColor": "hsl(344, 70%, 50%)",
    "donut": 18,
    "donutColor": "hsl(324, 70%, 50%)"
  },
  {
    "country": "AI",
    "hot dog": 55,
    "hot dogColor": "hsl(16, 70%, 50%)",
    "burger": 11,
    "burgerColor": "hsl(100, 70%, 50%)",
    "sandwich": 149,
    "sandwichColor": "hsl(42, 70%, 50%)",
    "kebab": 182,
    "kebabColor": "hsl(155, 70%, 50%)",
    "fries": 31,
    "friesColor": "hsl(43, 70%, 50%)",
    "donut": 44,
    "donutColor": "hsl(231, 70%, 50%)"
  },
  {
    "country": "AL",
    "hot dog": 117,
    "hot dogColor": "hsl(229, 70%, 50%)",
    "burger": 110,
    "burgerColor": "hsl(33, 70%, 50%)",
    "sandwich": 189,
    "sandwichColor": "hsl(121, 70%, 50%)",
    "kebab": 42,
    "kebabColor": "hsl(243, 70%, 50%)",
    "fries": 87,
    "friesColor": "hsl(340, 70%, 50%)",
    "donut": 10,
    "donutColor": "hsl(76, 70%, 50%)"
  },
  {
    "country": "AM",
    "hot dog": 120,
    "hot dogColor": "hsl(76, 70%, 50%)",
    "burger": 47,
    "burgerColor": "hsl(107, 70%, 50%)",
    "sandwich": 187,
    "sandwichColor": "hsl(271, 70%, 50%)",
    "kebab": 38,
    "kebabColor": "hsl(24, 70%, 50%)",
    "fries": 32,
    "friesColor": "hsl(3, 70%, 50%)",
    "donut": 149,
    "donutColor": "hsl(139, 70%, 50%)"
  }
]

export const mockDataPie=[
    {
      "id": "ruby",
      "label": "ruby",
      "value": 482,
      "color": "hsl(291, 70%, 50%)"
    },
    {
      "id": "php",
      "label": "php",
      "value": 114,
      "color": "hsl(95, 70%, 50%)"
    },
    {
      "id": "stylus",
      "label": "stylus",
      "value": 130,
      "color": "hsl(155, 70%, 50%)"
    },
    {
      "id": "scala",
      "label": "scala",
      "value": 200,
      "color": "hsl(271, 70%, 50%)"
    },
    {
      "id": "rust",
      "label": "rust",
      "value": 267,
      "color": "hsl(132, 70%, 50%)"
    }
  ]

  export const mockDataLineChart=[
    {
      "id": "japan",
      "color": tokens("dark").greenAccent[500],
      "data": [
        {
          "x": "plane",
          "y": 167
        },
        {
          "x": "helicopter",
          "y": 263
        },
        {
          "x": "boat",
          "y": 16
        },
        {
          "x": "train",
          "y": 76
        },
        {
          "x": "subway",
          "y": 16
        },
        {
          "x": "bus",
          "y": 143
        },
        {
          "x": "car",
          "y": 120
        },
        {
          "x": "moto",
          "y": 198
        },
        {
          "x": "bicycle",
          "y": 7
        },
        {
          "x": "horse",
          "y": 0
        },
        {
          "x": "skateboard",
          "y": 100
        },
        {
          "x": "others",
          "y": 197
        }
      ]
    },
    {
      "id": "france",
      "color": "hsl(114, 70%, 50%)",
      "data": [
        {
          "x": "plane",
          "y": 262
        },
        {
          "x": "helicopter",
          "y": 235
        },
        {
          "x": "boat",
          "y": 299
        },
        {
          "x": "train",
          "y": 284
        },
        {
          "x": "subway",
          "y": 173
        },
        {
          "x": "bus",
          "y": 284
        },
        {
          "x": "car",
          "y": 163
        },
        {
          "x": "moto",
          "y": 39
        },
        {
          "x": "bicycle",
          "y": 53
        },
        {
          "x": "horse",
          "y": 207
        },
        {
          "x": "skateboard",
          "y": 113
        },
        {
          "x": "others",
          "y": 70
        }
      ]
    },
    {
      "id": "us",
      "color": "hsl(159, 70%, 50%)",
      "data": [
        {
          "x": "plane",
          "y": 212
        },
        {
          "x": "helicopter",
          "y": 195
        },
        {
          "x": "boat",
          "y": 144
        },
        {
          "x": "train",
          "y": 250
        },
        {
          "x": "subway",
          "y": 58
        },
        {
          "x": "bus",
          "y": 30
        },
        {
          "x": "car",
          "y": 124
        },
        {
          "x": "moto",
          "y": 204
        },
        {
          "x": "bicycle",
          "y": 297
        },
        {
          "x": "horse",
          "y": 77
        },
        {
          "x": "skateboard",
          "y": 34
        },
        {
          "x": "others",
          "y": 136
        }
      ]
    },
    {
      "id": "germany",
      "color": "hsl(173, 70%, 50%)",
      "data": [
        {
          "x": "plane",
          "y": 40
        },
        {
          "x": "helicopter",
          "y": 100
        },
        {
          "x": "boat",
          "y": 103
        },
        {
          "x": "train",
          "y": 272
        },
        {
          "x": "subway",
          "y": 89
        },
        {
          "x": "bus",
          "y": 106
        },
        {
          "x": "car",
          "y": 239
        },
        {
          "x": "moto",
          "y": 28
        },
        {
          "x": "bicycle",
          "y": 35
        },
        {
          "x": "horse",
          "y": 271
        },
        {
          "x": "skateboard",
          "y": 240
        },
        {
          "x": "others",
          "y": 261
        }
      ]
    },
    {
      "id": "norway",
      "color": "hsl(331, 70%, 50%)",
      "data": [
        {
          "x": "plane",
          "y": 72
        },
        {
          "x": "helicopter",
          "y": 206
        },
        {
          "x": "boat",
          "y": 7
        },
        {
          "x": "train",
          "y": 194
        },
        {
          "x": "subway",
          "y": 277
        },
        {
          "x": "bus",
          "y": 43
        },
        {
          "x": "car",
          "y": 277
        },
        {
          "x": "moto",
          "y": 170
        },
        {
          "x": "bicycle",
          "y": 126
        },
        {
          "x": "horse",
          "y": 34
        },
        {
          "x": "skateboard",
          "y": 40
        },
        {
          "x": "others",
          "y": 290
        }
      ]
    }
  ]

  export const GeoData=[
    {
      "id": "AFG",
      "value": 467742
    },
    {
      "id": "AGO",
      "value": 792295
    },
    {
      "id": "ALB",
      "value": 121
    },
    {
      "id": "ARE",
      "value": 157895
    },
    {
      "id": "ARG",
      "value": 279917
    },
    {
      "id": "ARM",
      "value": 964442
    },
    {
      "id": "ATA",
      "value": 128122
    },
    {
      "id": "ATF",
      "value": 123026
    },
    {
      "id": "AUT",
      "value": 96975
    },
    {
      "id": "AZE",
      "value": 932710
    },
    {
      "id": "BDI",
      "value": 640896
    },
    {
      "id": "BEL",
      "value": 455807
    },
    {
      "id": "BEN",
      "value": 649269
    },
    {
      "id": "BFA",
      "value": 787546
    },
    {
      "id": "BGD",
      "value": 289991
    },
    {
      "id": "BGR",
      "value": 466067
    },
    {
      "id": "BHS",
      "value": 107487
    },
    {
      "id": "BIH",
      "value": 231724
    },
    {
      "id": "BLR",
      "value": 374348
    },
    {
      "id": "BLZ",
      "value": 54565
    },
    {
      "id": "BOL",
      "value": 303455
    },
    {
      "id": "BRN",
      "value": 363570
    },
    {
      "id": "BTN",
      "value": 22014
    },
    {
      "id": "BWA",
      "value": 400159
    },
    {
      "id": "CAF",
      "value": 773088
    },
    {
      "id": "CAN",
      "value": 489781
    },
    {
      "id": "CHE",
      "value": 981513
    },
    {
      "id": "CHL",
      "value": 345070
    },
    {
      "id": "CHN",
      "value": 780174
    },
    {
      "id": "CIV",
      "value": 645597
    },
    {
      "id": "CMR",
      "value": 662663
    },
    {
      "id": "COG",
      "value": 610410
    },
    {
      "id": "COL",
      "value": 880528
    },
    {
      "id": "CRI",
      "value": 654770
    },
    {
      "id": "CUB",
      "value": 924965
    },
    {
      "id": "-99",
      "value": 261399
    },
    {
      "id": "CYP",
      "value": 729426
    },
    {
      "id": "CZE",
      "value": 452046
    },
    {
      "id": "DEU",
      "value": 134028
    },
    {
      "id": "DJI",
      "value": 678528
    },
    {
      "id": "DNK",
      "value": 640182
    },
    {
      "id": "DOM",
      "value": 786157
    },
    {
      "id": "DZA",
      "value": 822235
    },
    {
      "id": "ECU",
      "value": 82768
    },
    {
      "id": "EGY",
      "value": 402777
    },
    {
      "id": "ERI",
      "value": 885732
    },
    {
      "id": "ESP",
      "value": 124734
    },
    {
      "id": "EST",
      "value": 274149
    },
    {
      "id": "ETH",
      "value": 73872
    },
    {
      "id": "FIN",
      "value": 454881
    },
    {
      "id": "FJI",
      "value": 325473
    },
    {
      "id": "FLK",
      "value": 331136
    },
    {
      "id": "FRA",
      "value": 409331
    },
    {
      "id": "GAB",
      "value": 509140
    },
    {
      "id": "GBR",
      "value": 828367
    },
    {
      "id": "GEO",
      "value": 921673
    },
    {
      "id": "GHA",
      "value": 381082
    },
    {
      "id": "GIN",
      "value": 892672
    },
    {
      "id": "GMB",
      "value": 933226
    },
    {
      "id": "GNB",
      "value": 948217
    },
    {
      "id": "GNQ",
      "value": 903430
    },
    {
      "id": "GRC",
      "value": 185728
    },
    {
      "id": "GTM",
      "value": 934173
    },
    {
      "id": "GUY",
      "value": 734644
    },
    {
      "id": "HND",
      "value": 669756
    },
    {
      "id": "HRV",
      "value": 511398
    },
    {
      "id": "HTI",
      "value": 867772
    },
    {
      "id": "HUN",
      "value": 176967
    },
    {
      "id": "IDN",
      "value": 680844
    },
    {
      "id": "IND",
      "value": 586797
    },
    {
      "id": "IRL",
      "value": 482041
    },
    {
      "id": "IRN",
      "value": 126044
    },
    {
      "id": "IRQ",
      "value": 325557
    },
    {
      "id": "ISL",
      "value": 808176
    },
    {
      "id": "ISR",
      "value": 959923
    },
    {
      "id": "ITA",
      "value": 833459
    },
    {
      "id": "JAM",
      "value": 917084
    },
    {
      "id": "JOR",
      "value": 761296
    },
    {
      "id": "JPN",
      "value": 95841
    },
    {
      "id": "KAZ",
      "value": 249267
    },
    {
      "id": "KEN",
      "value": 176035
    },
    {
      "id": "KGZ",
      "value": 455314
    },
    {
      "id": "KHM",
      "value": 356732
    },
    {
      "id": "OSA",
      "value": 47118
    },
    {
      "id": "KWT",
      "value": 561726
    },
    {
      "id": "LAO",
      "value": 712792
    },
    {
      "id": "LBN",
      "value": 614502
    },
    {
      "id": "LBR",
      "value": 55859
    },
    {
      "id": "LBY",
      "value": 17510
    },
    {
      "id": "LKA",
      "value": 552530
    },
    {
      "id": "LSO",
      "value": 651674
    },
    {
      "id": "LTU",
      "value": 491054
    },
    {
      "id": "LUX",
      "value": 628494
    },
    {
      "id": "LVA",
      "value": 770750
    },
    {
      "id": "MAR",
      "value": 42040
    },
    {
      "id": "MDA",
      "value": 865524
    },
    {
      "id": "MDG",
      "value": 340448
    },
    {
      "id": "MEX",
      "value": 918923
    },
    {
      "id": "MKD",
      "value": 368589
    },
    {
      "id": "MLI",
      "value": 893595
    },
    {
      "id": "MMR",
      "value": 923562
    },
    {
      "id": "MNE",
      "value": 100394
    },
    {
      "id": "MNG",
      "value": 707688
    },
    {
      "id": "MOZ",
      "value": 650413
    },
    {
      "id": "MRT",
      "value": 463690
    },
    {
      "id": "MWI",
      "value": 789156
    },
    {
      "id": "MYS",
      "value": 284493
    },
    {
      "id": "NAM",
      "value": 976180
    },
    {
      "id": "NCL",
      "value": 423102
    },
    {
      "id": "NER",
      "value": 353890
    },
    {
      "id": "NGA",
      "value": 518980
    },
    {
      "id": "NIC",
      "value": 112337
    },
    {
      "id": "NLD",
      "value": 165612
    },
    {
      "id": "NOR",
      "value": 816314
    },
    {
      "id": "NPL",
      "value": 739239
    },
    {
      "id": "NZL",
      "value": 438404
    },
    {
      "id": "OMN",
      "value": 905671
    },
    {
      "id": "PAK",
      "value": 760677
    },
    {
      "id": "PAN",
      "value": 376001
    },
    {
      "id": "PER",
      "value": 909430
    },
    {
      "id": "PHL",
      "value": 228920
    },
    {
      "id": "PNG",
      "value": 569732
    },
    {
      "id": "POL",
      "value": 878247
    },
    {
      "id": "PRI",
      "value": 808455
    },
    {
      "id": "PRT",
      "value": 390149
    },
    {
      "id": "PRY",
      "value": 160074
    },
    {
      "id": "QAT",
      "value": 686804
    },
    {
      "id": "ROU",
      "value": 420588
    },
    {
      "id": "RUS",
      "value": 417813
    },
    {
      "id": "RWA",
      "value": 225538
    },
    {
      "id": "ESH",
      "value": 777490
    },
    {
      "id": "SAU",
      "value": 504465
    },
    {
      "id": "SDN",
      "value": 405820
    },
    {
      "id": "SDS",
      "value": 173994
    },
    {
      "id": "SEN",
      "value": 164545
    },
    {
      "id": "SLB",
      "value": 592127
    },
    {
      "id": "SLE",
      "value": 281149
    },
    {
      "id": "SLV",
      "value": 240717
    },
    {
      "id": "ABV",
      "value": 631866
    },
    {
      "id": "SOM",
      "value": 672718
    },
    {
      "id": "SRB",
      "value": 632001
    },
    {
      "id": "SUR",
      "value": 754132
    },
    {
      "id": "SVK",
      "value": 861030
    },
    {
      "id": "SVN",
      "value": 536600
    },
    {
      "id": "SWZ",
      "value": 764500
    },
    {
      "id": "SYR",
      "value": 127088
    },
    {
      "id": "TCD",
      "value": 758038
    },
    {
      "id": "TGO",
      "value": 670137
    },
    {
      "id": "THA",
      "value": 798988
    },
    {
      "id": "TJK",
      "value": 522304
    },
    {
      "id": "TKM",
      "value": 619181
    },
    {
      "id": "TLS",
      "value": 583585
    },
    {
      "id": "TTO",
      "value": 729435
    },
    {
      "id": "TUN",
      "value": 540400
    },
    {
      "id": "TUR",
      "value": 659865
    },
    {
      "id": "TWN",
      "value": 592618
    },
    {
      "id": "TZA",
      "value": 995698
    },
    {
      "id": "UGA",
      "value": 47285
    },
    {
      "id": "UKR",
      "value": 376700
    },
    {
      "id": "URY",
      "value": 652716
    },
    {
      "id": "USA",
      "value": 604284
    },
    {
      "id": "UZB",
      "value": 142185
    },
    {
      "id": "VEN",
      "value": 339263
    },
    {
      "id": "VNM",
      "value": 435876
    },
    {
      "id": "VUT",
      "value": 842208
    },
    {
      "id": "PSE",
      "value": 326971
    },
    {
      "id": "YEM",
      "value": 314072
    },
    {
      "id": "ZAF",
      "value": 762727
    },
    {
      "id": "ZMB",
      "value": 277352
    },
    {
      "id": "ZWE",
      "value": 106896
    },
    {
      "id": "KOR",
      "value": 579547
    }
  ]

  export const transactionData=[
    {
      username:"denis mike",
      id:1,
      ttext:"123-003uf",
      cost:"234,899",
      date:"12-02-2023"
    },
    {
      username:"denis mike",
      id:2,
      ttext:"123-003uf",
      date:"12-02-2023",
      cost:"234,899",

    },
    {
      username:"denis mike",
      id:3,
      ttext:"123-003uf",
      cost:"234,899",
      date:"12-02-2023"

    },
    {
      username:"denis mike",
      id:4,
      ttext:"123-003uf",
      cost:"234,899",
      date:"12-02-2023"

    },
    {
      username:"denis mike",
      id:5,
      ttext:"123-003uf",
      cost:"234,899",
      date:"12-02-2023"

    },
  ]